export const AssemblyLineMenu = {
  routes: [
    {
      name: 'queues',
      displayName: 'menu.queues',
      subject_class: 'Queues'
    },

    {
      name: 'mounting',
      displayName: 'menu.mounting',
      subject_class: 'Mounting'
    },

    {
      name: 'conferencing',
      displayName: 'menu.conferencing',
      subject_class: 'Conferencing'
    },

    {
      name: 'stacking',
      displayName: 'menu.stacking',
      subject_class: 'Stacking'
    },

    {
      name: 'layer_picking',
      displayName: 'menu.layer_picking',
      subject_class: 'LayerPicking'
    },

    {
      name: 'conference_supervision',
      displayName: 'menu.conference_supervision',
      subject_class: 'ConferenceSupervision'
    },

    {
      name: 'vehicle_liberation',
      displayName: 'menu.vehicle_liberation',
      subject_class: 'VehicleLiberation'
    },

    {
      name: 'transporting',
      displayName: 'menu.transporting',
      subject_class: 'Transporting'
    },

    {
      name: 'finished',
      displayName: 'menu.finished',
      subject_class: 'Finished'
    },

    {
      name: 'allorders',
      displayName: 'menu.all_orders',
      subject_class: 'Finished'
    },
  ]
}